module.exports = __webpack_public_path__ + "static/BLOG-TITLE.1123da19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Blog/BLOG-TITLE.png
// module id = 206
// module chunks = 107818501498521 212839066777427